


























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component({
})
export default class Message extends Vue {
  @Prop(String) address!: string;
  @Prop(String) message!: string;
  @Prop(String) messageHash!: string;
  @Prop(String) signature!: string;
  @Emit('update:message')
  updateMessage (event: any) {
    console.log(event)
    return event
  }
}
